import { asArray } from './collections'

export { asArray } from './collections'

export function getUsageDailyTrendPoints(value) {
  if (Array.isArray(value)) return value
  return asArray(value?.points)
}